<template>
  <b-modal
    lazy
    centered
    size="md"
    :visible="show"
    hide-footer
    hide-header
    no-close-on-backdrop
    no-close-on-esc
  >
    <b-container fluid>
      <b-row>
        <b-col>
          <h4 class="text-info m-2">
            {{ $t("globals.new") + " Enum" }}:
          </h4>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-input
            class="mt-3"
            type="text"
            :placeholder="enumType"
            :state="true"
            disabled
          >
          </b-input>
          <b-input
            class="mt-3"
            type="text"
            v-model="name"
            :state="name != null && name.length > 0"
            :placeholder="$t('globals.name') + ' eg., Dummy Dongel'"
          >
          </b-input>
          <b-input
            class="mt-3"
            type="text"
            v-model="value"
            :state="value != null && value.length > 0"
            :placeholder="$t('globals.value') + ' eg., dummy_dongel'"
          >
          </b-input>
          <b-input
            class="mt-3"
            type="text"
            v-model="description"
            :placeholder="$t('globals.description')"
          >
          </b-input>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col>
          <b-btn
            style="float: right; margin: 0.3em;"
            @click="save"
            variant="success"
            :disabled="saveDisabled"
          >
            {{ $t("globals.save") }}
          </b-btn>
          <b-btn
            style="float: left; margin: 0.3em;"
            @click="cancelModal"
            variant="warning"
          >
            {{ $t("globals.cancel") }}
          </b-btn>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
import { mapMutations, mapActions } from "vuex";

export default {
  props: {
    show: Boolean,
    close: Function,
    enumType: String
  },
  data() {
    return {
      name: null,
      formated_value: null,
      description: null
    };
  },
  methods: {
    ...mapActions("axios_mod", ["simpleMutation"]),
    ...mapMutations(["setShowLoadingModal"]),
    save() {
      let data = {
        query: `
          mutation EnumCreate($enum: BillingEnumInput) {
            res: EnumCreate (enum: $enum)
          }
        `,
        variables: {
          enum: {
            enum_type: this.enumType,
            name: this.name.trim(),
            value: this.formated_value,
            description: this.description
          }
        }
      };

      this.simpleMutation({ data, this_ref: this }).then(() => {
        this.cancelModal();
      });
    },
    cancelModal() {
      this.name = null;
      this.formated_value = null;
      this.description = null;

      this.close();
    }
  },
  computed: {
    value: {
      get: function() {
        return this.formated_value;
      },
      set: function(new_value) {
        this.formated_value = new_value.toLowerCase().replace(" ", "_").replace("__", "_").replace(/^_\W+$_/, '');
      }
    },
    saveDisabled() {
      return (
        this.name == null
        || this.name.length == 0
        || this.value == null
        || this.value.length == 0
      )
    }
  },
  watch: {
    name(new_name) {
      this.value = new_name;
    }
  }
};
</script>
